<template>
  <div style="overflow: hidden;"
    :style="{ width: width + 'px', height: height + 'px', color: option.attribute.textColor, fontSize: option.attribute.fontSize + 'px' }"
    @click="clickHandler">
    <div ref="textNode" :class="option.attribute.scrollType === 1 ? 'hRow' : 'vRow'">{{ text }}</div>
  </div>
</template>

<script>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";

export default {
  name: "cpt-scroll-text",
  props: {
    option: Object,
    width: Number,
    height: Number,
    components: Array
    , current: Object
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      text: '',
      timer: null,
      uuid: null,
      newData: "",
      jsFunFlag: false,
    }
  },
  computed:{
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  watch: {
    'option.attribute': {
      handler(obj) {
        this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
        this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm, paras), this.components);
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)
        this.move();
      })
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) { // 没有全部配置映射字段
          //判断此控件在九宫格里面就不请求数据
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = { ...res[0] };
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            console.log(newres, '新数组');
            this.text = newres[0].value;
          }
        // } else { // 如果配置了转换脚本
        //   this.iptVal = res.value;
        // }
      } else { // 不是数据集类型，是静态数据
        this.text = res.value;
      }
    },
    move() {
      const that = this;
      let distanceX = 0;
      let distanceY = 0;
      that.$nextTick(() => {
        const textWidth = that.$refs.textNode.clientWidth;
        const textHeight = that.$refs.textNode.clientHeight;
        that.timer = setInterval(() => {
          if (that.option.attribute.scrollType === 1) {
            distanceX = distanceX - that.option.attribute.step
            if (-distanceX >= textWidth) {//位移超过文字宽度重新滚动
              distanceX = that.width
            }
            that.$refs.textNode.style.transform = 'translateX(' + distanceX + 'px)'
          } else {
            distanceY = distanceY - that.option.attribute.step;
            if (-distanceY >= textHeight) {
              distanceY = that.height
            }
            that.$refs.textNode.style.transform = 'translateY(' + distanceY + 'px)'
          }

        }, 60)
      });
    },
    clickHandler() {
      this.$emit("clickHandler", this.option.interaction, 'default', this.text, 'cpt-scroll-text', '', this.current)
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<style scoped>
.hRow {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vRow {
  width: 100%;
  word-wrap: break-word;
}
</style>
